import React, { useRef, useState, useEffect } from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import emailjs from "emailjs-com";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function CustomTextField({
  id,
  label,
  name,
  type = "text",
  autoFocus = false,
  ...otherProps
}) {
  return (
    <TextField
      margin="normal"
      required
      fullWidth
      id={id}
      label={label}
      name={name}
      type={type}
      autoComplete={name}
      autoFocus={autoFocus}
      color="secondary"
      style={styles.formField}
      InputProps={{
        style: {
          color: "whitesmoke",
        },
      }}
      InputLabelProps={{
        shrink: true,
        style: {
          // Add any additional styling here if needed
          // For example, adjust the color or the font size
          color: "rgba(255, 255, 255, 0.7)", // Example color adjustment
          fontSize: "1rem", // Example font size adjustment
          placeholder: styles.placeholder, // Example placeholder style
          // Position adjustments if needed
          transform: "translate(14px, -6px) scale(0.75)", // Adjust these values as needed
        },
      }}
      {...otherProps} // Spread any other props that might be passed
    />
  );
}

const styles = {
  paperContainer: {
    backgroundColor: "black", // Corrected property name
    height: "61vh",
    marginTop: "5%",
  },
  form: {
    boxShadow: "1px 2px 28px whitesmoke",
    padding: "14px",
  },
  formField: {
    border: "1px solid purple",
    // Removed opacity to make it brighter
    borderRadius: "10px",
    "& input": {
      // Corrected selector for targeting input styles
      color: "purple", // Consider changing to a brighter shade if necessary
    },
  },
  placeholder: {
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
    width: "100%",
    color: "whitesmoke", // Consider changing to a brighter shade if necessary
  },
};

function Contact() {
  const formRef = useRef();
  const [submissionMessage, setSubmissionMessage] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false);

  useEffect(() => {
    if (submissionMessage) {
      setOpenSnackbar(true);
    }
  }, [submissionMessage]);

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbar(false);
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    emailjs
      .sendForm(
        "service_op7na6f",
        "template_8fnx9z9",
        formRef.current,
        "YFMMXT0aIYIwFuUC_"
      )
      .then(
        (result) => {
          console.log(result.text);
          setSubmissionMessage(
            "Thank you for your message. We have received your information."
          );
        },
        (error) => {
          console.log(error.text);
          setSubmissionMessage(
            "Failed to send your message. Please try again later."
          );
        }
      );
  };

  return (
    <div>
      <Container component="main" maxWidth="xs">
        <Box
          component="form"
          ref={formRef}
          onSubmit={handleSubmit}
          noValidate
          sx={{ mt: 1 }}
        >
          <CustomTextField
            id="email"
            label="Email Address"
            name="email"
            autoFocus
          />

          <CustomTextField name="name" label="Name" id="name" />

          <CustomTextField
            name="comments"
            label="Comments"
            id="comments"
            type="comments"
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
          >
            Contact
          </Button>
          <Snackbar
            open={openSnackbar}
            autoHideDuration={6000}
            onClose={handleCloseSnackbar}
          >
            <Alert
              onClose={handleCloseSnackbar}
              severity="success"
              sx={{ width: "100%" }}
            >
              {submissionMessage}
            </Alert>
          </Snackbar>
        </Box>
      </Container>
    </div>
  );
}

export default Contact;
